<template>
  <div class="notfound">
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
</style>
